import { Box, Card, Typography } from "@mui/material";
import { colors, alphaVar } from "../../../../../../../../ui/colors";

interface Props {
  object: any;
  selected: boolean;
  onSelect: () => void;
}

export const ObjectsCard = ({ object, selected, onSelect }: Props) => {
  const highlight = selected ? colors.orange.base : colors.gray[100];
  const borderColor = selected ? alphaVar(colors.orange.base, 0.6) : alphaVar(colors.gray[200], 0.8);

  return (
    <Card
      onClick={onSelect}
      sx={{
        backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        borderRadius: 2,
        border: `2px solid ${borderColor}`,
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        transition: "all 0.2s ease",
        overflow: "hidden",
        cursor: "pointer",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: `0 6px 12px ${alphaVar(colors.orange.base, 0.25)}`,
          borderColor: alphaVar(colors.orange.base, 0.5),
        },
        height: 180,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        position: "relative",
      }}
    >
      <Box
        sx={{
          width: 100,
          height: 80,
          borderRadius: 2,
          //backgroundColor: alphaVar(highlight, 0.25),
          //border: `1px solid ${alphaVar(highlight, 0.6)}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          color: colors.gray[600],
          mb: 1,
          fontSize: 13,
        }}
      >
        <Box
          component="img"
          src={object.imageUrl}
          alt={object.name}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Nombre */}
      <Typography
        variant="subtitle2"
        fontWeight={700}
        sx={{
          color: selected ? colors.orange.base : colors.gray[600],
          fontSize: 13,
          textAlign: "center",
          mb: 0.5,
        }}
      >
        {object.name}
      </Typography>

      {/* Descripción */}
      <Typography
        variant="body2"
        sx={{
          color: colors.gray[500],
          fontSize: 12,
          textAlign: "center",
          mb: 1,
        }}
      >
        {object.description.replace(/@seed.*$/, "").trim()}
      </Typography>

      {/* Cost hidden
      <Typography
        variant="body2"
        fontWeight={600}
        sx={{
          color: selected ? colors.orange.base : colors.gray[400],
          fontSize: 13,
        }}
      >
        Cost: ${object.cost?.value ?? 0}
      </Typography>
      */}
    </Card>
  );
};
